import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { Context } from '../../../context/global-data-provider';
import './post-item-style.css';
// import { formatWithCommas } from "../../../func/helper";

function PostItem({ data }) {
  const discount = parseInt(data?.shop?.discount || data?.shop?.[0]?.discount, 10);
  const sold = parseInt(data?.shop?.sold || data?.shop?.[0]?.sold, 10);
  const { deletedPostManager } = useContext(Context);

  if (data.id !== undefined && !deletedPostManager.inList(data.id)) {
    const coverData = data.cover ? data.cover.split('.') : [];
    return (
      <div className="post-item f-100 d-block p-relative w-100">
        <Link to={`/post/${data.id}`}>
          <div className="post-body d-block w-100">
            <div className="post-content d-block o-hidden">
              {coverData[coverData.length - 1] === 'mp4' && (
                <video className="post-cover u-select-none" autoPlay={false} loop={false}>
                  <source src={data.cover} type="video/mp4" />
                </video>
              )}
              {coverData[coverData.length - 1] === 'jpg' && (
                <img
                  src={data.cover.replace('localhost/', 'localhost:98/')}
                  alt={data.title}
                  className="post-cover u-select-none"
                />
              )}
            </div>
          </div>
          {data.type !== 'single' && (
            <div className="post-type d-flex justify-content-start align-items-end">
              {data.type === 'video' && <span className="d-block mediatypesSpriteVideo__filled__32" label="video"></span>}
              {data.type === 'multi' && <span className="d-block mediatypesSpriteCarousel__filled__32"></span>}
            </div>
          )}
          {sold === 0 && discount > 0 && (
            <div className={'tile-badge-top-right'} style={{ paddingBottom: 0 }}>
              OFF
            </div>
          )}
          {sold === 1 && <div className={'tile-badge-top-right'}>فروخته شد</div>}
        </Link>

        {/*<div*/}
        {/*  style={*/}
        {/*    {*/}
        {/*      position: "absolute", top: "8px", left: "8px", fontSize: "14px", lineHeight: 1, background: "seagreen", letterSpacing: '1px',*/}
        {/*      padding: "4px 6px 2px", boxShadow: "0 2px 5px 1px rgba(0,0,0,.3)", borderRadius:'3px',color:'white',zIndex:1*/}
        {/*    }*/}
        {/*  }*/}
        {/*>*/}
        {/*  {formatWithCommas(data.place)}*/}
        {/*</div>*/}
      </div>
    );
  } else {
    return <div className="post-item f-100 d-block p-relative w-100" />;
  }
}

export default React.memo(PostItem);
